import React from 'react';

export default function Cart({ items, onUpdateQty }) {
  if (items.length === 0) {
    return (
      <div className="bg-white p-4 shadow rounded-lg h-fit">
        <h3 className="text-lg font-semibold mb-3">Cart</h3>
        <p className="text-sm text-gray-500">Cart is empty.</p>
      </div>
    );
  }

  const total = items.reduce((sum, item) => sum + item.price * item.qty, 0);

  return (
    <div className="bg-white p-4 shadow rounded-lg h-fit">
      <h3 className="text-lg font-semibold mb-3">Cart</h3>
      <div className="space-y-3">
        {items.map((item) => (
          <div key={item.id} className="border rounded p-2">
            <p className="font-medium text-sm">{item.name}</p>
            <p className="text-sm">P{item.price}</p>
            <div className="flex items-center gap-2 mt-2">
              <button
                type="button"
                className="min-touch px-3 py-2 sm:px-2 sm:py-1 border rounded text-lg sm:text-base flex items-center justify-center"
                onClick={() => onUpdateQty(item.id, item.qty - 1)}
                aria-label="Decrease quantity"
              >
                −
              </button>
              <span className="text-sm min-w-[1.5rem] text-center">{item.qty}</span>
              <button
                type="button"
                className="min-touch px-3 py-2 sm:px-2 sm:py-1 border rounded text-lg sm:text-base flex items-center justify-center"
                onClick={() => onUpdateQty(item.id, item.qty + 1)}
                aria-label="Increase quantity"
              >
                +
              </button>
            </div>
          </div>
        ))}
      </div>
      <p className="mt-4 font-semibold">Total: P{total.toFixed(2)}</p>
    </div>
  );
}
